import { Crown, Tag } from "lucide-react";
import { useT } from "@/lib/i18n";

const COLORS = {
  basic_deal: "bg-[#E1231A]", last_minute: "bg-[#FF567D]", early_bird: "bg-[#00A698]", mobile: "bg-[#5392F9]",
  geo: "bg-indigo-500", member: "bg-[#FFB700] text-slate-900", promo_code: "bg-emerald-600", campaign: "bg-fuchsia-600", flash_sale: "bg-orange-500",
};

export const PromoBadges = ({ promos = [], testid }) => { const t = useT(); return (
  <div className="flex flex-wrap gap-1" data-testid={testid}>
    {promos.map((p) => (
      <span key={p.id} className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-bold text-white ${COLORS[p.kind] || "bg-slate-600"}`}>
        <Tag className="h-3 w-3" />{t(p.label)} -{p.discount_percent}%
      </span>
    ))}
  </div>
); };

export const MemberTeaser = ({ price, idr, testid }) => price ? (
  <p data-testid={testid} className="flex items-center justify-end gap-1 text-xs font-semibold text-amber-700">
    <Crown className="h-3.5 w-3.5 text-[#FFB700]" /> Member: {idr(price)}
  </p>
) : null;
